import React from 'react';
import { Heading, Stack, IStackProps } from '@grubhubprod/gh-cookbook-react';

export type DataTableTitleProps = {
  children: React.ReactNode;
} & Pick<IStackProps, 'x' | 'y'>;

export const DataTableTitle: React.FC<DataTableTitleProps> = ({
  children,
  x = 'none',
  y = 'none',
}) => (
  <Stack x={x} y={y} flex="0 0 auto">
    <Heading variant="h4">{children}</Heading>
  </Stack>
);
